var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form signed-application-popup"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": "Zavrieť"
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Podpísaná žiadosť")])]), _c('div', {
    staticClass: "signed-application-popup__body"
  }, [_c('div', {
    staticClass: "signed-application-popup__logo-wrap"
  }, [_vm.payload.application.bank && _vm.payload.application.bank.logo_square ? _c('img', {
    staticClass: "signed-application-popup__logo",
    attrs: {
      "src": _vm.payload.application.bank.logo_square,
      "alt": ""
    }
  }) : _vm._e()]), _vm._m(0)]), _c('div', {
    staticClass: "signed-application-popup__actions"
  }, [_c('button', {
    staticClass: "signed-application-popup__secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.markWithoutScan
    }
  }, [_c('span', {
    staticClass: "signed-application-popup__choice-icon"
  }, [_vm._v("✓")]), _c('span', {
    staticClass: "signed-application-popup__choice-copy"
  }, [_c('strong', [_vm._v(_vm._s(_vm.saving ? "Ukladám…" : "Nie, iba označiť"))]), _c('small', [_vm._v("Bez nahratia dokumentu")])])]), _c('button', {
    staticClass: "signed-application-popup__primary",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.payload.applicationCloud
    },
    on: {
      "click": _vm.openSignedUpload
    }
  }, [_c('span', {
    staticClass: "signed-application-popup__choice-icon signed-application-popup__upload-icon"
  }, [_vm._v("↑")]), _vm._m(1)])]), !_vm.payload.applicationCloud ? _c('p', {
    staticClass: "clientError signed-application-popup__error"
  }, [_vm._v(" Cloud žiadosti sa ešte nenačítal. Žiadosť môžete označiť bez skenu alebo modal otvoriť znova. ")]) : _vm._e()])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "signed-application-popup__copy"
  }, [_c('div', {
    staticClass: "signed-application-popup__eyebrow"
  }, [_vm._v("Dokončenie podpisu")]), _c('h2', {
    staticClass: "signed-application-popup__question"
  }, [_vm._v("Chcete nahrať aj podpísanú žiadosť?")]), _c('p', {
    staticClass: "signed-application-popup__description"
  }, [_vm._v(" Vyberte, či chcete iba zmeniť stav, alebo spolu s tým uložiť podpísaný dokument do cloudu klienta. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "signed-application-popup__choice-copy"
  }, [_c('strong', [_vm._v("Áno, nahrať sken")]), _c('small', [_vm._v("PDF alebo fotografie")])]);

}]

export { render, staticRenderFns }